import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

@Component({
  selector: 'so-loader-ui',
  standalone: true,
  imports: [],
  templateUrl: './so-loader.component.html',
  styleUrl: './so-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoLoaderUI {
  size = input<string>('18px');
  color = input<string>('--so-primary');

  protected resolvedColor = computed(() => {
    const c = this.color();
    return c.startsWith('--') ? `var(${c})` : c;
  });
}
